var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Customers',"subtitle":`Business - ${_vm.$route.params.id ? 'Edit':'Add new'}  account`}}),(_vm.loading)?_c('p',[_vm._v("Loading...")]):_c('add-business-form',{attrs:{"action":_vm.$route.params.id ? 'edit' : 'add',"account":_vm.account}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }